<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full rounded-xl p-3">
                    <div class="text-center text-lg pb-5 pt-3">
                        <div class="text-center text-30 text-blue-1 pt-3" v-html="title"></div>
                        <div class="pt-3 text-22 text-gray-1" v-html="message"></div>
                        <div class="flex-col flex-1 px-2.5">
                            <InputText
                                class="promocode-input w-full"
                                v-model:inputValue="lblInputCode"
                                :errorInfo="formErrorInfo[0]"
                                :inputLbl="fromLbl"
                                :isShowError="isShowError"
                                :isSubmitted="isSubmitted"
                                :maxLength="12"
                                :isUpperCase="true"
                                @update:inputValue="updateInput()">
                            </InputText>
                        </div>
                        <div class="text-22 text-green-1 underline" @click="clickCondition()">
                            เงื่อนไขการร่วมสนุก
                        </div>
                    </div>
                    <div class="pb-6 px-3">
                        <button class="w-full text-22 text-white rounded-r-full rounded-l-full py-2.5"
                                :class="lblInputCode ? 'bg-green-1' : 'bg-a-gray-c6c6c6'" @click="clickOk()">
                            {{btnOk}}
                        </button>
                    </div>
                </div>
                <div class="flex absolute -bottom-5 left-0 w-full">
                    <img class="w-10 h-10 m-auto" @click="clickCancel()" src="@/assets/icon/ic-close.svg" alt=""/>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import { FormHelper } from '@/helper/FormHelper.js';
import InputText from '@/components/Input/label/InputText.vue';
import BzbsRedeem from '@/core/Redeem/service/BzbsRedeem.js';
import { RedeemConfigBuilder } from '@/core/Redeem/config/RedeemConfigBuilder.js';

export default {
    name: "VerifyCodeModal",
    mixins: [LocaleMixin],
    components: {
        InputText
    },
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,

            tag: '',
            title: '',
            message: '',
            btnOk: '',
            btnCancel: '',
            busModal: null,

            lblInputCode: '',
            formErrorInfo: [],
            fromLbl: {},
            correct: false,

            redeemConfigBuilder: new RedeemConfigBuilder(),
            selectedQuantity: null,
            selectedCampaignId: null,

            isVerifyCode: null,
            isShowErr: false,
            isSubmitted: false,
            isShowError: true,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
        this.formErrorInfo = FormHelper.genErrorInfo(1);
        let lbl = {
            name: '',
            placeholder: 'กรอกโค้ดที่นี่',
            required: '',
            too_short: '',
            invalid: '',
        };
        this.fromLbl = lbl;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function(config) {
            console.log(config)
            this.tag = config.tag;
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;
            this.campaignId = config.campaignId;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.button.confirm;
            }
            if (Util.isEmptyStr(this.btnCancel)) {
                this.btnCancel = this.lbl.button.cancel;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: async function() {
            if (this.lblInputCode == '') return ;
            this.isSubmitted = true;
            this.isVerifyCode = await this.redeem();
            if (this.isVerifyCode) {
                this.hide();
                this.controller.sendCallbackOk(this.lblInputCode);
                this.lblInputCode = '';
            } else {
                this.isShowErr = true;
                this.formErrorInfo[0].isValid = false
            }
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel();
            this.lblInputCode = '';
        },
        updateInput: function() {
            this.isShowErr = false;
            this.isSubmitted = false;
            this.formErrorInfo[0].isValid = true
        },
        redeem: async function() {
            let params = this.redeemConfigBuilder.getRedeemParams();
            this.selectedCampaignId = this.campaignId;
            this.selectedQuantity = 1;
            params.verifycode = this.lblInputCode;

            return new Promise((resolve) => {
                BzbsRedeem.apiRedeemCampaign(this.selectedCampaignId, params, this.selectedQuantity).subscribe({
                    next: (data) => {
                        console.log(data)
                        resolve(true);
                    },
                    error: (err) => {
                        if (err.code === 409) {
                            if(err.id === 1) {
                                this.formErrorInfo[0].msg = 'ขออภัย คุณใช้สิทธิ์ครบตามจำนวนที่กำหนด กรุณาร่วมสนุกใหม่ในครั้งถัดไป'
                            } else if (err.id === 2) {
                                this.formErrorInfo[0].msg = this.lbl.surprise.maxPerPerson
                            }  else if (err.id === 3) {
                                this.formErrorInfo[0].msg = this.lbl.surprise.redeemCoolDown
                            } else if (err.id === 1403) {
                                this.formErrorInfo[0].msg = this.lbl.surprise.condition
                            } else if (err.id === 2021) {
                                this.formErrorInfo[0].msg = 'ขออภัย โค้ดนี้ถูกใช้งานไปแล้ว กรุณากรอกโค้ดใหม่'
                            } else {
                                this.formErrorInfo[0].msg = err.message
                            }
                        }
                        else if (err.code === 404) {
                            if(err.id === 404) {
                                this.formErrorInfo[0].msg = 'โค้ดของคุณไม่ถูกต้อง กรุณากรอกใหม่อีกครั้ง'
                            } else {
                                this.formErrorInfo[0].msg = err.message
                            }
                        } else {
                            this.formErrorInfo[0].msg = err.message
                        }
                        resolve(false);
                    }
                });
            });
        },
        clickCondition: function() {
            this.hide();
            this.controller.sendCallbackCondition();
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;
        .modal-content {
            overflow: unset;
            width: 100%;
            max-width: 414px;
            padding: 0 16px;
        }
    }
</style>
<style lang="scss">
    .promocode-input {
        input {
            text-align: center;
        }
        ::placeholder {
            text-align: center;
        }
    }
</style>
